import MarketplaceLanding from './MarketplaceLanding.view';

export default MarketplaceLanding;
